import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class ImageAPI {
    public static async createNew(formData: FormData) {
        let image;

        try {
            image =
                await ApiController.post(ApiRoutes.image.create, formData) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(image);
    }

    public static async updateExisting(file: any) {
        let image;

        const request = {
            data: {
                type: 'images',
                id: file.uid,
                attributes: {
                    title: file.title,
                },
            },
        };

        try {
            image =
                await ApiController.patch(ApiRoutes.image.update(file.uid), request) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(image);
    }

}
